import React from 'react';
import { StatusDetail } from '../../../api';
import { formatDate } from '../../../services/primitives/date-utils';
import { getStatusCategoryCode, getStatusCode } from '../../../services';
import { renderAmount } from '../../data-table';
import * as S from './status.styles';

export const StatusDetails: React.FC<{ details: StatusDetail[] }> = ({ details }) => {
    return (
        <div>
            {details.map((detail, i) => {
                return (
                    <S.DetailContainer key={i}>
                        {detail.effectiveDate && (
                            <S.GroupItemTitle>Status as of {formatDate(detail.effectiveDate, 'MM/dd/yyyy')}</S.GroupItemTitle>
                        )}
                        <S.DetailsList>
                            {detail.categoryCode1 && (
                                <li>
                                    <S.MessageItem>{getStatusCategoryCode(detail.categoryCode1)}</S.MessageItem>
                                </li>
                            )}
                            {detail.statusCode1 && (
                                <li>
                                    <S.MessageItem>{getStatusCode(detail.statusCode1)}</S.MessageItem>
                                </li>
                            )}
                            {detail.categoryCode2 && (
                                <li>
                                    <S.MessageItem>{getStatusCategoryCode(detail.categoryCode2)}</S.MessageItem>
                                </li>
                            )}
                            {detail.statusCode2 && (
                                <li>
                                    <S.MessageItem>{getStatusCode(detail.statusCode2)}</S.MessageItem>
                                </li>
                            )}
                            {detail.categoryCode3 && (
                                <li>
                                    <S.MessageItem>{getStatusCategoryCode(detail.categoryCode3)}</S.MessageItem>
                                </li>
                            )}
                            {detail.statusCode3 && (
                                <li>
                                    <S.MessageItem>{getStatusCode(detail.statusCode3)}</S.MessageItem>
                                </li>
                            )}
                        </S.DetailsList>
                        <S.DetailsBody>
                            {!!detail?.remittanceTraceNumber && (
                                <S.LabelRowVertical>
                                    <S.Label>Check Number</S.Label> <S.Value>{detail.remittanceTraceNumber}</S.Value>
                                </S.LabelRowVertical>
                            )}
                            {!!detail?.remittanceDate && (
                                <S.LabelRowVertical>
                                    <S.Label>Check Date</S.Label> <S.Value>{formatDate(detail.remittanceDate, 'MM/dd/yyyy')}</S.Value>
                                </S.LabelRowVertical>
                            )}
                            {!!detail?.totalChargeAmount && (
                                <S.LabelRowVertical>
                                    <S.Label>Billed</S.Label>{' '}
                                    <S.Value>{renderAmount(detail.totalChargeAmount)}</S.Value>
                                </S.LabelRowVertical>
                            )}
                            {!!detail?.totalPaidAmount && (
                                <S.LabelRowVertical>
                                    <S.Label>Paid</S.Label> <S.Value>{renderAmount(detail.totalPaidAmount)}</S.Value>
                                </S.LabelRowVertical>
                            )}
                        </S.DetailsBody>
                    </S.DetailContainer>
                );
            })}
        </div>
    );
};
